export const USER_NOT_EXISTS = "The user does not exist.";
export const LOGIN_REDIRECT = "Session expired. <br> Please login again.";
export const SELECT_CUSTOMER = "Please select a customer.";
export const SHORT_EXCESS = "Adjust the remaining quantity to short/excess?";
export const CREATE_GRN = "Product quantity cannot be less than 1.";
export const PRINT_NOT_WORKING =
  "Please check if your printer is connected/working.";
// export const LICENCE_EXPIRED = "License expired. Please contact store manager.";
export const LICENCE_EXPIRED =
  "Your license has expired. <br> Please contact ZWING Support for renewal.";
export const OPENING_BALANCE = "No opening balance entered.";
export const INTERNAL_SERVER_ERROR = "Something isn't right. Please try again.";
export const PROFILE_SUCCESS = "Profile updated successfully.";
export const MANUAL_DISCOUNT = "Manual Discount applied successfully.";
export const BIG_DISCOUNT =
  "The applied Manual Discount is greater than the payable amount.";
export const REMOVED_MANUAL_DISCOUNT = "Manual Discount removed successfully.";
export const CUSTOMER_TAGGED = "Customer tagged successfully.";
export const CUSTOMER_UNTAGGED = "Customer untagged.";
export const CUSTOMER_MANDATORY = "Customer tagging is mandatory";
export const CUSTOMER_MANDATORY_INFO =
  "Please tag the customer to continue with checkout.";
export const CARRYBAG_ADDED = "Carry bag(s) added successfully.";
export const REMARK_ADDED = "Remark added successfully.";
export const REMARK_REMOVED = "Remark removed.";
export const LOGOUT_MESSAGE = "Are you sure you want to logout?";
export const SPLIT_MESSAGE =
  "You cannot go back when you are in Split Payment mode, Tap ‘Dismiss’ to complete the payment process or press ‘Cancel Bill’ if you wish to start a new bill.";
// export const SPLIT_MESSAGE =
//   "You cannot go back when you are in Split Payment mode, Tap ‘Return to Payment’ to complete the payment process or press ‘Cancel Bill’ if you wish to start a new bill.";
export const OFFLINE_MESSAGE =
  "You are not connected to the Internet. Some actions will remain unavailable till you go Online.";
export const ONLINE_MESSAGE =
  "You are now connected to the internet. All actions are now available.";
export const UNTAG_LAYBY = "Are you sure want to untag Lay-by ?";
export const HOLDBILL_MESSAGE = "Do you want to hold the current bill?";
export const HOLDBILL_SUCCESS = "Current bill held successfully.";
export const HOLDBILL_FAIL = "Open session first to hold the bill.";
export const HELDBILL_MESSAGE_EMPTY =
  "Do you want to recall the selected bill?";
export const HELDBILL_MESSAGE =
  "Current bill will be deleted, Do you still want to recall the selected bill?";
export const SALESPERSON_TAGGED = "Salesperson tagged successfully.";
export const SALESPERSON_UNTAGGED = "Salesperson untagged.";
export const REFRESH_CATALOG = "Catalog refreshed successfully.";
export const MAX_CART_ITEMS = "Maximum cart limit reached.";
export const MAX_PRODUCT_QTY =
  "Unable to update quantity as maximum limit reached.";
export const VOUCHER_SUCCESS = "Voucher applied successfully.";
export const REMOVE_DEFAULT_PRINTER = "Default printer removed successfully.";
export const FULL_GRN =
  "Status for all the product(s) need to be updated before creating a GRN.";
export const GRN_SUCCESS = "GRN created successfully.";
export const INVALID_SEARCH_TERM = "No record found. Please try again.";
export const LAY_BY_UNTAGGED = "Lay-by untagged.";
export const LAY_BY_TAGGED = "Lay-by tagged successfully.";
export const NO_SALESPERSON = "No Salespersons assigned to this store.";
export const INCORRECT_TIME =
  "Your system clock is incorrect. Please set your clock to the current date & time.";
export const APPROVED_DISMISSED = "Request: ";
export const CASH_MANAGEMENT_REQ = "Request sent successfully.";
export const BILL_AMT_GREATER = "Entered amount is greater than bill amount.";
export const CLOSE_SESSION = "Close Session before you Logout";
export const OPEN_SESSION = "Open Session before continuing";
export const OPEN_SESSION_INFO =
  "Please start a new session to start retailing on your POS device.";
export const SESSION_MNGMT_DISABLED = "Session Management is disabled.";
export const INVALID_MANUAL_DISCOUNT =
  "Manual Discount should be less than bill amount. <br> Please apply Manual Discount again.";
export const DECIDE_OFFLINE =
  "<strong>No Internet Access</strong><br><br>To continue the current bill in Offline mode press 'Continue' or press 'Cancel Bill' to cancel this bill and make a new bill Online.";
export const DECIDE_OFFLINE_ORDER =
  "<h6 class='fw-normal mb-3'>Internet Access Restored</h6>Please continue this bill in Offline mode to avoid loss of data, You'll be automatically switched Online after completion.";
export const PHONEPE_MSG = {
  TIME_OUT:
    "The transaction could not be completed as the session timed out. (PAYMENT_PENDING)",
  CANCELLED:
    "The transaction could not be completed as the transaction was cancelled by the merchant. (PAYMENT_CANCELLED)",
  DECLINED:
    "The transaction could not be completed as the payment was declined by the user. (PAYMENT_DECLINED)",
  SERVER_ERROR: "The transaction could not be completed. ",
  PENDING: "Transaction is still pending.",
};
export const INTERNET_UNAVAILABLE =
  "<h6>No Internet Access</h6> Please check that your internet connection is working or wait till connection is restored.";
export const INTERNET_AVAILABLE =
  "<p class='fs-14 py-2 px-1'>Internet Access Restored</p> Your internet connection is up and running. You may now resume where you left.";
export const INTERNET_OFFLINE =
  "<h6 class='mb-3'>Going Offline</h6> No internet connection detected.<br>The POS will now operate in Offline mode.";
export const INTERNET_ONLINE =
  "<h6 class='mb-3'>Going Online</h6>Your internet connection is up and running. <br>The POS will return to Online mode.";
export const ADHOC_RETURN_OFFLINE_CANCEL =
  "Return cannot be processed in offline mode, Please cancel this transaction to continue.";
export const ORDER_POS_OFFLINE_CANCEL =
  "Order POS doesn't work in offline mode, Please cancel this transaction to continue.";
export const PRICE_OVERRIDE_SUCCESS = "Price overridden successfully.";
export const ACCOUNT_SALE_NOT_AVAILABLE =
  "On-account sale is not enabled for this customer.";
export const AMT_GREATER =
  "Entered amount is greater than the debit note amount.";
export const BILL_MD_ALREADY_APPLIED =
  "Item Manual Discount cannot be applied after Bill Manual Discount. Please remove Bill Manual Discount before applying Item Manual Discount for this product.";
export const CUSTOMER_GROUP_UPDATED = "Customer groups updated successfully.";
export const EMPTY_CATALOG =
  "Catalog is empty, please try refreshing the catalog.";
// export const NO_VOUCHER_FOUND = "No voucher found";
export const VOUCHER_ADDED = "Voucher(s) added successfully";
export const VOUCHER_REMOVED = "Voucher removed successfully";
export const VOUCHER_GROUP_REMOVED = "Voucher group removed successfully";
export const VOUCHER_QTY_UPDATE = "Voucher Qty. updated successfully";
export const VOUCHER_SALE_VALUE_UPDATE =
  "Voucher sale value updated successfully";
export const VOUCHER_MOBILE_TAG = "Mobile number tagged successfully";
export const VOUCHER_MOBILE_UNTAG = "Mobile number untagged successfully";
export const VOUCHER_ALREADY_AVAILABLE = "Voucher already present in the list";
export const NO_BATCH =
  "This product cannot be added to the cart as no batch has been added. Please contact your store manager";
export const NO_SERIAL =
  "This product cannot be added to the cart as no serial has been added. Please contact your store manager";
export const INSUFFICIENT_INVENTORY_TITLE = "Insufficient Inventory";
export const ORDER_INSUFFICIENT_INVENTORY =
  "This product cannot be added to the order, please scan or select another product.";
export const STOCK_UNAVAILABLE = "Stock not available for this product.";
export const STORE_CASH_THRESHOLD = "Store cash limit is";
export const DISCARDED_PRODUCT = "This product is discarded";
export const REPLACE_SUCCESS = "Product replaced successfully";
export const SAME_BARCODE = "Product cannot be replaced with same barcode.";
export const FIELDS_COMP = "Marked fields are compulsory.";
export const INV_UNAV = "Inventory of some products is unavilable";
export const EXPIRED_BATCH =
  "The batch you have selected is expired. Press 'Dismiss' to select another batch or press 'Continue' to continue adding this batch.";
